import { QueryHookOptions, useQuery } from '@apollo/client'
import gql from 'graphql-tag'
import { DELETION_REQUEST_FRAGMENT } from './DeletionRequestFragments'
import { DeletionRequestsQuery, DeletionRequestsQueryVariables } from './apollo-graphql-generated/DeletionRequestsQuery'
import { DeletionRequestQuery, DeletionRequestQueryVariables } from './apollo-graphql-generated/DeletionRequestQuery'

export const DELETION_REQUESTS_QUERY = gql`
query DeletionRequestsQuery($status: DeletionRequestStatus, $entityType: DeletionEntityType, $first: Int, $skip: Int) {
  deletionRequests(status: $status, entityType: $entityType, first: $first, skip: $skip) {
    ...DeletionRequestFragment
  }
}
${DELETION_REQUEST_FRAGMENT}
`

export const DELETION_REQUEST_QUERY = gql`
query DeletionRequestQuery($id: String!) {
  deletionRequest(id: $id) {
    ...DeletionRequestFragment
  }
}
${DELETION_REQUEST_FRAGMENT}
`

export function useDeletionRequestsQuery(options?: QueryHookOptions<DeletionRequestsQuery, DeletionRequestsQueryVariables>) {
  return useQuery<DeletionRequestsQuery, DeletionRequestsQueryVariables>(DELETION_REQUESTS_QUERY, options)
}

export function useDeletionRequestQuery(options?: QueryHookOptions<DeletionRequestQuery, DeletionRequestQueryVariables>) {
  return useQuery<DeletionRequestQuery, DeletionRequestQueryVariables>(DELETION_REQUEST_QUERY, options)
}
